"use strict";

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var styles_1 = require("@material-ui/core/styles");

var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));

var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var Menu_1 = __importDefault(require("@material-ui/icons/Menu"));

var react_router_dom_1 = require("react-router-dom");

var drawerWidth = 240;
var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    toolbar: {
      paddingRight: theme.spacing(3)
    },
    appBar: {
      backgroundColor: theme.palette.primary.main,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)"),
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    title: {
      flexGrow: 1
    },
    search: _defineProperty({
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: styles_1.fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: styles_1.fade(theme.palette.common.white, 0.25)
      },
      marginLeft: 0,
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }),
    inputRoot: {
      color: 'inherit'
    },
    inputInput: _defineProperty({
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 120,
      '&:focus': {
        width: 200
      }
    }),
    iconButton: {
      color: '#fff'
    }
  };
});

var Menu = function Menu(props) {
  var list = props.list;
  var classes = useStyles();
  return react_1.default.createElement(react_1.default.Fragment, null, list.map(function (l, i) {
    return react_1.default.createElement(react_router_dom_1.Link, {
      key: i,
      to: l.link
    }, react_1.default.createElement(IconButton_1.default, {
      className: classes.iconButton
    }, react_1.default.createElement(l.Icon, null)));
  }));
};

var Top = function Top(props) {
  var title = props.title,
      menus = props.menus,
      isOpen = props.isOpen,
      onToggle = props.onToggle,
      className = props.className,
      CustomComponent = props.CustomComponent;
  var classes = useStyles();

  var handleDrawerOpen = function handleDrawerOpen() {
    onToggle && onToggle(isOpen ? isOpen : false);
  };

  return react_1.default.createElement(AppBar_1.default, {
    position: "absolute",
    className: clsx_1.default(classes.appBar, isOpen && classes.appBarShift, className)
  }, react_1.default.createElement(Toolbar_1.default, {
    className: classes.toolbar
  }, typeof isOpen !== 'undefined' && onToggle && react_1.default.createElement(IconButton_1.default, {
    edge: "start",
    color: "inherit",
    "aria-label": "open drawer",
    onClick: handleDrawerOpen
  }, react_1.default.createElement(Menu_1.default, null)), react_1.default.createElement(Typography_1.default, {
    component: "h1",
    variant: "h6",
    color: "inherit",
    noWrap: true,
    className: classes.title
  }, title), CustomComponent && react_1.default.createElement(CustomComponent, null), react_1.default.createElement(Menu, {
    list: menus
  })));
};

exports.default = Top;